module.exports = __webpack_public_path__ + "assets/e88c2c100b4fa978e94a886c388c879d-DSC_0818.jpg";